import { Link } from 'react-router-dom';

import { useDocumentTitle } from '../lib/useDocumentTitle';

export function NotFound() {
  useDocumentTitle('Page not found - Neomaris');

  return (
    <section className="page-hero page-hero--solo">
      <h1 className="reveal">Page not found</h1>
      <p className="reveal reveal-delay-1">
        The page you&apos;re looking for doesn&apos;t exist, or has moved.
      </p>
      <div className="hero-cta">
        <Link to="/" className="btn btn-primary">
          Back to home
        </Link>
      </div>
    </section>
  );
}
